<template>
  <div>
    <section-title>
      Players - in turn order
    </section-title>

    <player-row
      v-for="playerId in playerOrder"
      :key="playerId"
      :player="players[playerId]"
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import SectionTitle from "@/components/SectionTitle";
import PlayerRow from "@/components/PlayerRow";
import { NS_GAME_STATE } from "@/store/constants";

export default {
  name: "AllPlayers",

  components: {
    PlayerRow,
    SectionTitle,
  },

  computed: {
    ...mapGetters(NS_GAME_STATE, [
      'players',
      'playerOrder',
    ])
  }
}
</script>

<style scoped>

</style>
